import { useRef, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const SceneEntry = () => {
  const sectionRef = useRef(null);
  
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end start"]
  });
  
  const logoScale = useTransform(scrollYProgress, [0, 0.5], [1, 0.8]);
  const logoOpacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);
  const contentY = useTransform(scrollYProgress, [0, 0.5], [0, -100]);
  
  const scrollToPackages = () => {
    document.getElementById('identity-gate')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      ref={sectionRef}
      className="scene relative min-h-screen flex items-center justify-center overflow-hidden"
      id="entry"
    >
      {/* Dark gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-frmla-dark" />
      
      {/* Subtle radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_hsla(38,50%,60%,0.03)_0%,_transparent_70%)]" />
      
      <motion.div 
        className="relative z-10 flex flex-col items-center text-center px-6"
        style={{ y: contentY }}
      >
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          style={{ scale: logoScale, opacity: logoOpacity }}
          className="mb-8"
        >
          <img 
            src="/frmla-logo.png" 
            alt="FRMLA Creative" 
            className="w-[300px] md:w-[450px] lg:w-[600px] h-auto"
          />
        </motion.div>
        
        {/* Tagline */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16"
        >
          <p className="font-body text-sm md:text-base tracking-[0.3em] text-muted-foreground uppercase">
            Structured Branding & Design Packages
          </p>
          <div className="gold-line w-32 mx-auto mt-6" />
          <p className="font-body text-xs md:text-sm tracking-[0.2em] text-muted-foreground mt-6 uppercase">
            Built on formula. Systems over guesswork.
          </p>
        </motion.div>
        
        {/* CTA - Command, not button */}
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 1, ease: [0.16, 1, 0.3, 1] }}
          onClick={scrollToPackages}
          className="btn-command"
        >
          VIEW PACKAGES
        </motion.button>
      </motion.div>
      
      {/* Scroll indicator */}
      <motion.div 
        className="scroll-indicator"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 0.6 }}
      >
        <ChevronDown className="w-8 h-8 text-muted-foreground" />
      </motion.div>
    </section>
  );
};

export default SceneEntry;
